<div class="container-crewcontact-detail" *ngIf="crewMemberDetails$ | async as crewMember ; else loading">
    <div class="c-col" *ngIf="appService.theme$ | async as theme">
        @if(crewMember.response){
        <div class="c-block-row">
            <div class="pilots-col c-col">
                <div class="c-info-row c-row">
                    <div class="c-seat-col c-col">
                        <div>{{crewMember.response.seat}}</div>
                    </div>

                    <div class="c-name-col">
                        <div class="c-name-row">{{crewMember.response.name}}</div>
                        <div class="c-empNum-row">{{crewMember.response.employeeNumber}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="c-contact-col c-col">
            <!-- EMAIL -->
            @if(crewMember.response.primaryEmail && crewMember.response.primaryEmail.length > 1 &&
            crewMember.response.primaryEmail != 'Official Use Only' && crewMember.response.primaryEmail != 'Emergency Use Only') {
            <div class="c-contact-row c-row">
                <img style="width:24px; height: 24px;"
                    [src]="theme == 'light' ? emailIconLight : emailIconDark" />
                    <a [href]="'email:' + crewMember.response.primaryEmail">
                        <button class="contact-button" >{{crewMember.response.primaryEmail}}</button>
                    </a>
            </div>
            }
            @else if (crewMember.response.primaryEmail == 'Official Use Only' || crewMember.response.primaryEmail == 'Emergency Use Only') {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="emailIconNone" />
                    <div style="color: red">{{crewMember.response.primaryEmail }}</div>
                </div>
            }
            @else {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="emailIconNone" />
                    <div [style]="{'color': 'red', 'padding': '1px 6px 1px 6px'}">Not on file</div>
                </div>
            }


            <!-- SMS -->
            @if(crewMember.response.cell && crewMember.response.cell.length > 1
            && crewMember.response.cell != 'Official Use Only' && crewMember.response.cell != 'Emergency Use Only') {
            <div class="c-contact-row c-row">
                <img style="width:24px; height: 24px;"
                    [src]="theme == 'light' ? smsIconLight : smsIconDark" />
                    <a [href]="'sms:' + crewMember.response.cell">
                        <button class="contact-button" >{{crewMember.response.cell}}</button>
                    </a>
            </div>
            }
            @else if (crewMember.response.cell == 'Official Use Only' || crewMember.response.cell == 'Emergency Use Only') {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="smsIconNone" />
                    <div style="color: red">{{crewMember.response.cell}}</div>
                </div>
            }
            @else {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="smsIconNone" />
                    <div [style]="{'color': 'red', 'padding': '1px 6px 1px 6px'}">Not on file</div>
                </div>
            }


            <!-- CELL -->
            @if(crewMember.response.cell && crewMember.response.cell.length > 1
            && crewMember.response.cell != 'Official Use Only' && crewMember.response.cell != 'Emergency Use Only') {
            <div class="c-contact-row c-row">
                <img style="width:24px; height: 24px;"
                    [src]="theme == 'light' ? phoneIconLight : phoneIconDark" />
                <a [href]="'tel:' + crewMember.response.cell">
                    <button class="contact-button" >{{crewMember.response.cell}}</button>
                </a>
            </div>
            }
            @else if (crewMember.response.cell == 'Official Use Only' || crewMember.response.cell == 'Emergency Use Only') {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="phoneIconNone" />
                    <div style="color: red">{{crewMember.response.cell}}</div>
                </div>
            }
            @else {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="phoneIconNone" />
                    <div [style]="{'color': 'red', 'padding': '1px 6px 1px 6px'}">Not on file</div>
                </div>
            }


            <!-- TELEPHONE -->
            @if(crewMember.response.telephone && crewMember.response.telephone.length > 1 
            && crewMember.response.telephone != 'Official Use Only' && crewMember.response.telephone != 'Emergency Use Only') {
            <div class="c-contact-row c-row">
                <img style="width:24px; height: 24px;"
                    [src]="theme == 'light' ? telephoneIconLight : telephoneIconDark" />
                <a [href]="'tel:' + crewMember.response.telephone">
                    <button class="contact-button" >{{crewMember.response.telephone}}</button>
                </a>
            </div>
            }
            @else if (crewMember.response.cell == 'Official Use Only' || crewMember.response.cell == 'Emergency Use Only') {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="telephoneIconNone" />
                    <div style="color: red">{{crewMember.response.telephone}}</div>
                </div>
            }
            @else {
                <div class="c-contact-row c-row">
                    <img style="width: 24px; height: 24px;" [src]="telephoneIconNone" />
                    <div [style]="{'color': 'red', 'padding': '1px 6px 1px 6px'}">Not on file</div>
                </div>
            }
        </div>

        }
    </div>
</div>
<ng-template #loading>
    <div class="container-crewcontact-detail">
        <div class="c-col" *ngIf="appService.theme$ | async as theme">
            <div class="pilots-col c-col">
                <div class="c-info-row c-row">
                    <div class="c-seat-col c-col">
                        <p-skeleton width="24px" height="21px" />
                    </div>
                    <div class="c-name-col">
                        <p-skeleton width="165px" height="21px" styleClass="mr-2" />
                        <p-skeleton width="165px" height="21px" styleClass="mr-2" />
                    </div>
                </div>
            </div>
            <div class="c-contact-col c-col">
                <div class="c-contact-row c-row">
                    <img style="width:24px; height: 24px;"
                        [src]="theme == 'light' ? emailIconLight : emailIconDark" />
                    <p-skeleton width="183px" height="21px" styleClass="mr-2" />    
                </div>
                <div class="c-contact-row c-row">
                    <img style="width:24px; height: 24px;"
                        [src]="theme == 'light' ? smsIconLight :smsIconDark" />
                    <p-skeleton width="183px" height="21px" styleClass="mr-2" />    
                </div>
                <div class="c-contact-row c-row">
                    <img style="width:24px; height: 24px;"
                        [src]="theme == 'light' ? phoneIconLight : phoneIconDark" />
                    <p-skeleton width="183px" height="21px" styleClass="mr-2" />    
                </div>
                <div class="c-contact-row c-row">
                    <img style="width:24px; height: 24px;"
                        [src]="theme == 'light' ? telephoneIconLight : telephoneIconDark" />
                    <p-skeleton width="183px" height="21px" styleClass="mr-2" />    
                </div>
            </div>
        </div>
    </div>
</ng-template>